import { ChangePassword } from "@low6dev/react-feature-auth/dist";
import { useTranslations } from "hooks";
import history from "router/history";
import { toast } from "react-toastify";

import styled from "styled-components";

const StyledWrapper = styled.div``;

const Wrapper = () => {
  const [translations] = useTranslations();

  const handleSuccess = () => {
    toast.success(`${translations.changePasswordSuccess}`);
    history.push("/profile");
  };

  const handleError = () => {
    toast.error(`${translations.changePasswordError}`);
  };

  return (
    <StyledWrapper>
      <ChangePassword
        translations={translations}
        onBackClicked={() => history.push("/profile")}
        onSuccess={handleSuccess}
        onError={handleError}
      />
    </StyledWrapper>
  );
};

export default Wrapper;
